import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IEmailLogsPagedResult, IEmailLogsQuery } from '../models/email-logs/email-event';

@Injectable({
  providedIn: 'root',
})
export class EmailLogsService {
  constructor(private http: HttpClient) {}

  listEmailLogs(query: IEmailLogsQuery): Observable<IEmailLogsPagedResult> {
    if (isDevMode()) {
      console.log('[DEV] [EmailLogsService] loading email logs', query);
    }
    return this.http.get<IEmailLogsPagedResult>(`${environment.apiBase}/email-logs`, {
      params: this.buildParams(query),
    });
  }

  private buildParams(query: IEmailLogsQuery): HttpParams {
    const withPageNumber = new HttpParams().set('pageNumber', query.pageNumber.toString());
    const withPageSize = withPageNumber.set('pageSize', query.pageSize.toString());
    const withEmail = query.email ? withPageSize.set('email', query.email) : withPageSize;
    const withTypes = (query.types ?? []).reduce(
      (params, type) => params.append('types', type),
      withEmail,
    );
    const withSince = query.since ? withTypes.set('since', query.since) : withTypes;
    const withUntil = query.until ? withSince.set('until', query.until) : withSince;
    return withUntil;
  }
}
